import {
  call,
  put,
  takeLatest,
  all,
  getContext,
  select,
  take,
  takeEvery,
} from "redux-saga/effects";

import {
  sagaApiActionsConstructor,
  sagaApiListenerConstructor,
} from "../helpers";
import {
  createFirestoreDocumentArrayChannel,
  createFirestoreCollectionChannel,
} from "../helpers";
import { getProfileInfo } from "../../api/firestore/search";
import {
  setNewChat,
  addNewMessage,
  subscribeToNewChat,
  setRecieverNotification,
  getChatArrayInfo,
  getChatInfo,
  getChatDocRef,
  getChatCollectionRef,
  updateMessageContent,
  getRecieverUidByChatId,
  removeChatPetition,
  acceptChatPetition,
  addOwnNewChatPetition,
  validateChatRequests,
  removeChatPetitionReverse,
  deleteChat,
  setMessagesRead,
  getChatMessages,
  deleteChatDocument,
  deleteChatFromChatList,
} from "../../api/firestore/chat";
import { uploadChatFile, deleteChatFolder } from "../../api/storage";
import { getUid } from "../../api/auth";

const { requestStart, requestError, requestSuccess } =
  sagaApiActionsConstructor("chat");

const sagaApiListeners = sagaApiListenerConstructor("chat");

function* chatInitSaga({ payload }) {
  try {
    const { chats, chatsRequests } = payload;

    yield put({
      type: "chat/getChatMenuInfo",
      payload: { chats, chatsRequests },
    });

    yield put({
      type: "chat/subscribeToChats",
      payload: { chats: chats || [], chatsRequests: chatsRequests || [] },
    });
  } catch (e) {
    console.log(e);
  }
}

function* subscribeToChatsSaga({ payload }) {
  try {
    const { chats, chatsRequests } = payload;
    const finalChatRequests = chatsRequests.map((chat) => chat?.chatId);
    const finalChats = [...finalChatRequests, ...chats];

    const { currentChat } = yield select((state) => state.chat);

    if (finalChats.length === 0) {
      return;
    }

    const chatRefs = finalChats.map((chat) => getChatDocRef({ chatId: chat }));
    const channel = yield call(createFirestoreDocumentArrayChannel, chatRefs);

    while (true) {
      const { data, error } = yield take(channel);

      if (data) {
        yield put({
          type: "chat/updateChatListInfo",
          payload: { data: data, id: data.id },
        });

        if (currentChat.chatId && data.id === currentChat.chatId) {
          yield put({
            type: "chat/getChatMessages",
            payload: { chatId: data.id },
          });
        }
      }

      if (error) {
        console.log(error);
      }
    }
  } catch (e) {
    console.log("subscribeToChatsSaga");
    console.log(e);
  }
}

function* openChatSaga({ payload }) {
  try {
    const router = yield getContext("router");
    const { uid } = yield call(getUid);
    const url = [uid, payload.uid].sort().join("_");

    router.navigate(`/chat/${url}`);
  } catch (e) {
    console.log(e);
  }
}

function* addMessageToDatabaseSaga({ payload }) {
  try {
    const { chatId, content, type } = payload;

    switch (type) {
      case "text":
        yield call(addNewMessage, { chatId, content, type });

        break;

      case "image":
        const { data, extension, isHorizontal } = content;

        if (data && extension) {
          const messageId = yield call(addNewMessage, {
            chatId,
            content: "pending",
            horizontal: isHorizontal,
            type,
          });

          const imageUrl = yield call(uploadChatFile, {
            chatId,
            data,
            extension,
          });

          yield call(updateMessageContent, {
            chatId,
            messageId,
            content: imageUrl,
          });
        }

        break;

      default:
        break;
    }

    yield requestSuccess();
  } catch (e) {
    console.log(e);
  }
}

function* sendMessageSaga({ payload }) {
  try {
    const { currentChat } = yield select((state) => state.chat);
    const { newChat, hasAccepted, chatId } = currentChat;
    const { content, type } = payload;

    if (newChat) {
      yield sendFirstMessageSaga({ payload });
    } else if (hasAccepted) {
      yield put({
        type: "chat/addMessageToDatabase",
        payload: { chatId, content, type },
      });
    }
  } catch (e) {
    yield requestError();
    console.log(e);
  }
}

function* sendFirstMessageSaga({ payload }) {
  try {
    yield put({ type: "chat/setDisabledInputState", payload: true });
    yield requestStart();
    const { chatId } = yield select((state) => state.chat.currentChat);

    const { content, type } = payload;

    yield call(setNewChat, {
      chatId,
      content: content,
      type: type,
    });

    yield put({
      type: "chat/addMessageToDatabase",
      payload: { chatId, content, type },
    });

    // abe-aquí
    yield call(addOwnNewChatPetition, { chatId });
    yield call(setRecieverNotification, { chatId });

    yield put({ type: "chat/setDisabledInputState", payload: false });
    yield requestSuccess();
  } catch (e) {
    console.log(e);
    yield put({ type: "chat/setDisabledInputState", payload: false });
    yield requestError("No hemos podido enviar tu mensaje");
  }
}

function* getChatMenuInfoSaga({ payload }) {
  try {
    const { chats, chatsRequests } = payload;
    let finalRes = {};
    let finalChatArr = [];

    yield requestStart();
    if (chatsRequests) {
      yield call(validateChatRequests, { chatsRequests });

      const requestArr = chatsRequests.map((chat) => chat.chatId);
      finalChatArr = [...finalChatArr, ...requestArr];
    }

    if (chats) {
      finalChatArr = [...finalChatArr, ...chats];
    }

    if (finalChatArr.length > 0) {
      finalRes = yield call(getChatArrayInfo, { chats: finalChatArr });
    }

    yield put({
      type: "chat/setFullChatList",
      payload: finalRes,
    });

    yield requestSuccess();
  } catch (e) {
    yield requestError("No hemos podido encontrar tus conversaciones");
    console.log(e);
  }
}

//
function* initNewChatSaga({ payload }) {
  try {
    yield requestStart();
    yield put({ type: "chat/clearChatInfo" });

    const chatList = yield select((state) => state.chat.chatList);

    const { uid } = yield call(getUid);
    const { chatId } = payload;

    try {
    } catch (e) {
      // console.log(e);
    }

    yield put({ type: "chat/setChatId", payload: { chatId } });

    let finalChatInfo = {};

    if (!chatId) {
      yield put({
        type: "chat/setCurrentChatInfo",
        payload: { ...chatList, chatId: chatId },
      });

      yield requestSuccess();
      return;
    }

    const chatInList = chatList[chatId];

    if (!chatInList) {
      const recieverUid = chatId.replace(`${uid}`, "").replace("_", "");

      let newChat = yield call(getProfileInfo, recieverUid);

      yield put({
        type: "chat/appendChatToChatList",
        payload: {
          chat: {
            lastMessage: {
              type: "text",
              content: null,
              timestamp: Date.now(),
            },
            name: newChat.name,
            surname: newChat.surname,
            uid: recieverUid,
            profilePicture: newChat.profilePicture,
            chatId: chatId,
            timestamp: Date.now(),
          },
        },
      });

      finalChatInfo = {
        name: newChat.name,
        surname: newChat.surname,
        profilePicture: newChat.profilePicture,
        chatId: chatId,
      };
    } else {
      finalChatInfo = {
        name: chatInList.name,
        surname: chatInList.surname,
        profilePicture: chatInList.profilePicture,
        chatId: chatId,
      };
    }

    yield put({ type: "chat/setCurrentChatInfo", payload: finalChatInfo });

    let chatInfo = null;

    try {
      chatInfo = yield call(getChatInfo, { chatId });
    } catch (e) {
      console.log("AQUÍ FALLA");
    }

    if (chatInfo) {
      const { uid } = yield call(getUid);
      const isChatRequest = !chatInfo.accepted[uid];

      const hasAccepted = chatInfo?.participants?.reduce((acc, item) => {
        return acc && !!chatInfo.accepted?.[item];
      }, true);

      yield put({
        type: "chat/setCurrentChat",
        payload: {
          hasAccepted: hasAccepted,
          newChat: false,
          chatId: chatId,
          firstMessage: chatInfo.firstMessage,
          isChatRequest: isChatRequest,
        },
      });
    } else {
      yield put({
        type: "chat/setCurrentChat",
        payload: {
          hasAccepted: true,
          newChat: true,
          chatId: chatId,
          firstMessage: {
            content: null,
            from: null,
            to: null,
            timestamp: Date.now(),
            type: "text",
          },
          isChatRequest: false,
        },
      });
    }

    yield requestSuccess();
  } catch (e) {
    console.log(e);
    yield requestError();
  }
}

// abe-aquí
function* getChatMessagesSaga({ payload }) {
  try {
    const { chatId } = payload;
    let chatInfo = null;
    let messagesRef = null;

    try {
      chatInfo = yield call(getChatInfo, { chatId });
      messagesRef = yield call(getChatCollectionRef, {
        chatId,
        timestamp: chatInfo.firstMessage.timestamp,
      });
    } catch (e) {
      console.log("FALLA AQUÍ");
    }

    if (!chatInfo) {
      yield put({
        type: "chat/setCurrentChat",
        payload: {
          hasAccepted: false,
          newChat: true,
          chatId: chatId,
          firstMessage: {
            content: null,
            from: null,
            to: null,
            timestamp: Date.now(),
            type: "text",
          },
          isChatRequest: false,
        },
      });
      yield requestSuccess();
      return;
    }

    const { uid } = yield call(getUid);
    const channel = yield call(createFirestoreCollectionChannel, messagesRef);
    const isChatRequest = !chatInfo.accepted[uid];
    const hasAccepted = chatInfo?.participants?.reduce((acc, item) => {
      return acc && !!chatInfo.accepted?.[item];
    }, true);

    while (true) {
      const { data, error } = yield take(channel);

      if (data) {
        yield put({
          type: "chat/setCurrentChat",
          payload: {
            hasAccepted: hasAccepted,
            newChat: false,
            chatId: chatId,
            firstMessage: chatInfo.firstMessage,
            isChatRequest: isChatRequest,
          },
        });

        yield put({
          type: "chat/setMessages",
          payload: data,
        });
      } else {
      }

      if (error) {
        yield requestError();
      }
    }
  } catch (e) {
    yield requestError("No hemos podido recuperar tus mensajes");
    console.log(e);
  }
}

function* goToCurrentChatProfileSaga() {
  try {
    const { chatId } = yield select((state) => state.chat.currentChat);
    const recieverUid = getRecieverUidByChatId(chatId);
    const router = yield getContext("router");

    router.navigate(`/search/profiles/${recieverUid}`);
  } catch (e) {
    console.log(e);
  }
}

function* acceptChatInvitationSaga() {
  try {
    const { chatId } = yield select((state) => state.chat.currentChat);
    const { name, surname } = yield select((state) => state.main.user);

    yield call(acceptChatPetition, { chatId });
    yield call(subscribeToNewChat, { chatId });
    yield call(removeChatPetition, { chatId });

    yield call(addNewMessage, {
      chatId,
      content: `${name} ${surname} aceptó la invitación`,
      type: "info",
    });
  } catch (e) {
    console.log({ ERROR_ACCEPT: e });
  }
}

function* rejectChatInvitationSaga() {
  try {
    const { chatId } = yield select((state) => state.chat.currentChat);
    const router = yield getContext("router");
    yield call(removeChatPetition, { chatId });
    yield call(removeChatPetitionReverse, { chatId });
    yield call(deleteChat, { chatId });

    router.navigate("/chat");
  } catch (e) {}
}

function* readMessagesSaga() {
  try {
    console.log("THIS IS WOOOORKING!");
    const { chatId } = yield select((state) => state.chat.currentChat);

    yield call(setMessagesRead, { chatId });
  } catch (e) {
    console.log(e);
  }
}

function* goToProfileSaga() {
  try {
    const { chatId } = yield select((state) => state.chat.currentChat);
    const recieverUid = getRecieverUidByChatId(chatId);
    const router = yield getContext("router");

    router.navigate(`/search/profiles/${recieverUid}`);
  } catch (e) {
    console.log(e);
  }
}

function* deleteCurrentChatSaga() {
  yield requestStart();

  try {
    const { currentChat } = yield select((state) => state.chat);
    const chatId = currentChat?.chatId;

    yield call(deleteChatFolder, { chatId });
    yield call(deleteChatDocument, { chatId });
    yield call(deleteChatFromChatList, { chatId });

    yield requestSuccess("/chat");
  } catch (e) {
    console.log("deleteCurrentChatSaga", e);
    yield requestError("Algo ha ido mal!");
  }
  return null;
}

function* chatRootSaga() {
  yield all([
    takeLatest("chat/init", chatInitSaga),
    takeLatest("chat/openChat", openChatSaga),
    takeLatest("chat/sendMessage", sendMessageSaga),
    takeEvery("chat/getChatMenuInfo", getChatMenuInfoSaga),
    takeLatest("chat/getChatMessages", getChatMessagesSaga),
    takeLatest("chat/initNewChat", initNewChatSaga),
    takeLatest("chat/goToCurrentChatProfile", goToCurrentChatProfileSaga),
    takeLatest("chat/acceptChatInvitation", acceptChatInvitationSaga),
    takeLatest("chat/rejectChatInvitation", rejectChatInvitationSaga),
    takeEvery("chat/subscribeToChats", subscribeToChatsSaga),
    takeEvery("chat/addMessageToDatabase", addMessageToDatabaseSaga),
    takeLatest("chat/readMessages", readMessagesSaga),
    takeLatest("chat/goToProfile", goToProfileSaga),
    takeLatest("chat/deleteCurrentChat", deleteCurrentChatSaga),
    ...sagaApiListeners,
  ]);
}

export default chatRootSaga;
